import React from 'react';
import { connect } from 'react-redux';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';

class DocFormSubmitButton extends React.Component {
    render(){
        const { pristine,submitting,invalid,gorgon } = this.props;
        const { formError } = gorgon;
       
        if (!invalid && !Object.keys(formError).length > 0){
            return (
                <div>
                    <button type="button" onClick={()=> this.props.submitOpenActionDialog()} 
                    className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
                </div>    
            )
        }
        return null;
    }
}

const mapStateToProps = (state, ownProps) => {
    return state;
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      submitOpenActionDialog: ()=> {
        dispatch(actConfDlgActions.openDialog())    
      },
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DocFormSubmitButton);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormSubmitButton.js